import { render, staticRenderFns } from "./ModalMidia.vue?vue&type=template&id=964ce65c&scoped=true"
import script from "./ModalMidia.vue?vue&type=script&lang=js"
export * from "./ModalMidia.vue?vue&type=script&lang=js"
import style0 from "./ModalMidia.vue?vue&type=style&index=0&id=964ce65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964ce65c",
  null
  
)

export default component.exports